import React from 'react';
import classNames from 'classnames';

import SEO from '../components/SEO';
import LegalNav from '../components/LegalNav';
import RenderStaticHTML from '../components/RenderStaticHTML';

import privacyContent from '../data/privacy-content.js';

const nsBase = 'page';
const ns = `${ nsBase }-legal`;

const pageContent = privacyContent;

const PrivacyPolicy = () => {
	const rootClassnames = classNames({
		[`page-privacy-policy`]: true,
		[`${ ns }`]: true,
	});

	return (
		<div className={rootClassnames}>
			<SEO title={'Privacy policies'} />
			<LegalNav />
			<div className={`${ ns }__page`}>
				<div className={'container-fluid'}>
					<h1 className={`${ ns }__title`}>Privacy Policies</h1>
					<div className={`${ ns }__content`}>
						<RenderStaticHTML html={pageContent} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PrivacyPolicy;
